import { useContext } from "react";
import { AppContext } from "../../../../../lib/appContext";
import { ProductContext } from "../../../context/product";
import { getAttributesProps } from "./helpers/getAttributesProps";
import { getHeaderProps } from "./helpers/getHeaderProps";
import { ICta } from "../../../../../models/product";

export const useDetailContentProps = (onClickCta?: ICta["onClick"]) => {
  const appContext = useContext(AppContext);
  const { product, loading } = useContext(ProductContext);
  if (loading || !product) {
    return { loading: true };
  }

  return {
    attributeProps: getAttributesProps(product),
    headerProps: getHeaderProps(appContext, product, onClickCta),
    loading: false
  };
};
